import template from './bf-amazon-connection-assistant-logo.html.twig';
import './bf-amazon-connection-assistant-logo.scss';

Shopware.Component.register('bf-amazon-connection-assistant-logo', {
    template
});
